// @flow
import createAnalyticsSaga from '@rover/react-lib/redux/createAnalyticsSaga';
import {
  actions as creditCardsActions,
  selectors as creditCardsSelectors,
} from '@rover/react-lib/redux/ducks/creditCards.duck';

import { selectors as conversationsCheckoutPageSelectors } from '../ConversationsCheckoutPage.duck';

const getData = (state: any, action: any) => {
  switch (action.type) {
    case creditCardsActions.createCreditCardAttempt.actionType:
      return {
        event: 'owner-conversion-checkout-save-card',
        serviceType: conversationsCheckoutPageSelectors.getServiceType(state),
        errorMessage: creditCardsSelectors.getErrorMessage(state),
      };
    case creditCardsActions.updateCreditCardAttempt.actionType:
      return {
        event: 'owner-conversion-checkout-update-card',
        serviceType: conversationsCheckoutPageSelectors.getServiceType(state),
        errorMessage: creditCardsSelectors.getErrorMessage(state),
      };
    default:
      return null;
  }
};

export default createAnalyticsSaga(
  [
    creditCardsActions.createCreditCardAttempt.actionType,
    creditCardsActions.updateCreditCardAttempt.actionType,
  ],
  getData
);



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/ConversationsCheckoutPage/sagas/analytics.js